import i18n from '@shared/i18n'
import { IMessage } from '@shared/models/proto/base/messages'
import { useVideoCallConfigsStore } from '@shared/store/video-call-configs'
import { handleUserFullName } from '@shared/utils/helpers/user-name'

import { MessageType } from '@protots/chat/message_type'

export const useVideoCallNotifications = (message: IMessage) => {
  const videoConfigsStore = useVideoCallConfigsStore()

  const allowedTypes = [
    MessageType.TEXT,
    MessageType.IMAGE,
    MessageType.QUICK_FORM,
    MessageType.VIDEO,
  ]

  if (
    allowedTypes.includes(message.messageType) &&
    isPlainMessage(message) &&
    videoConfigsStore.isVideoChatMode
  ) {
    const participantName = handleUserFullName(
      i18n.global.t('unknown'),
      message.sender?.firstName,
      message.sender?.lastName
    )

    const messageAttachmentText = message.text
      ? `${message.text} ${i18n.global.t('chat.labels.withAttachment')} `
      : i18n.global.t('chat.labels.receivedAttachment')

    const messageText =
      message.messageType === MessageType.TEXT
        ? message.text
        : messageAttachmentText

    videoConfigsStore.setTroubleShootingMessageWindow(
      true,
      messageText,
      participantName,
      message.sender?.id
    )
  }
}

const isPlainMessage = (message: IMessage) => {
  try {
    const parsedText = JSON.parse(message.text)
    return !parsedText.inputType
  } catch (e) {
    return true
  }
}
